import { CommonService } from 'src/app/_Core/_Services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';

@Component({
  standalone: false,
  selector: 'app-profile-verification',
  templateUrl: './profile-verification.component.html',
  styleUrls: ['./profile-verification.component.scss']
})
export class ProfileVerificationComponent implements OnInit {
  email: any;
  data: any;

  constructor(private route:ActivatedRoute,private apiSrv:CommonService,
    private router: Router,
    private appStateSrv: AppStateProvider,

    ) {

  }

  ngOnInit(): void {
    if(localStorage.getItem('token') != null) {
      this.apiSrv.logoutToken().subscribe(res => {
        localStorage.clear()
        this.router.navigateByUrl("");
        window.location.reload();
      });
    }
    this.appStateSrv.setLoginStatus(false);
    this.route.queryParams.subscribe(res=>{
      this.email=res?.emaild
      this.getResponse(this.email)
    })
  }


  getResponse(data){

    this.apiSrv.verifyEmailForApp(data).subscribe(res=>{
      this.data=(res?.isValid==true)? res.successMsg:res.errorMsg
    })
  }


}
